import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import timezonesComponent from './timezones.component';

let timezonesModule = angular
  .module('timezones', [
    uiRouter
  ])
  .component('timezones', timezonesComponent)
  .name;

export default timezonesModule;



// WEBPACK FOOTER //
// ./src/app/components/timezones/timezones.module.js